import PropTypes from "prop-types";
import {
    Container,
    Bar,
} from "./ProgressBar.styles";

const ProgressBar = ({ percent, height }) => {
    return (
        <Container>
            <Bar style={{ width: `${percent}%`, height: height }} />
        </Container>
    );
};

ProgressBar.defaultProps = {
    percent: 0,
    height: "0.5rem",
};

ProgressBar.propTypes = {
    percent: PropTypes.number,
    height: PropTypes.string,
};

export default ProgressBar;
